import classNames from 'classnames';
import React, { FC } from 'react';
import * as ReactModal from 'react-modal';
import { Button } from './Button';
import ClickAwayListener from 'react-click-away-listener';
import { StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  ariaLabeledBy: string;
  className?: string;
  withoutCloseBtn?: boolean;
}

export const Modal: FC<ModalProps> = (props) => {
  const { isOpen, onClose, ariaLabeledBy, className, children, withoutCloseBtn = false } = props;

  ReactModal.setAppElement("body");

  return (
    <ReactModal
      className="insuranceModal"
      overlayClassName="insuranceModal__outer"
      portalClassName="insuranceModal__portal"
      isOpen={isOpen}
      aria={{
        describedby: ariaLabeledBy,
      }}
      shouldCloseOnEsc
      onRequestClose={onClose}
    >
      <div className="insuranceModal__inner">
        <ClickAwayListener onClickAway={onClose}>
          <div className={classNames("insuranceModal__content", className)}>
            {!withoutCloseBtn && (
              <Button
                className="insuranceModal__closeButton"
                onClick={onClose}
                size="small"
                type="clear"
                tier="primary"
                tabIndex={1}
              >
                <StreamLineIcon iconName="s-close" />
                <span className="insuranceModal__closeButtonLabel">
                  Close
                </span>
              </Button>
            )}
            {children}
          </div>
        </ClickAwayListener>
      </div>
    </ReactModal>
  );
};
